import { useEffect, useState } from "react";
import api from "../lib/api";
import { gapText } from "./AdminNotifications";

const DAY_CHOICES = [7, 14, 30];

// Admin: Premium members who used to come by but have not been seen for a while.
export default function AdminAtRisk() {
  const [days, setDays] = useState(14);
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get("/admin/at-risk", { params: { days } })
      .then((r) => { if (alive) { setData(r.data); setFailed(false); } })
      .catch(() => { if (alive) setFailed(true); });
    return () => { alive = false; };
  }, [days]);

  return (
    <div data-testid="admin-at-risk">
      <h2 className="font-display text-2xl font-bold mb-4">Premium members who may be slipping away</h2>
      <div className="bg-zinc-900/60 border border-white/10 rounded-2xl p-4 sm:p-6">
        <p className="text-xs text-zinc-500">Premium members who have not visited for a while. Reach out before they cancel. Only members whose visits have been recorded since tracking began are listed.</p>
        <div className="mt-3 flex flex-wrap items-center gap-2" role="group" aria-label="Not seen for">
          <span className="text-sm text-zinc-300">Not seen for</span>
          {DAY_CHOICES.map((d) => (
            <button key={d} type="button" onClick={() => setDays(d)} aria-pressed={days === d} data-testid={`admin-at-risk-days-${d}`}
              className={`px-3 py-1.5 rounded-full border text-xs ${days === d ? "border-cyan-400/60 bg-cyan-400/10 text-cyan-200" : "border-white/15 text-zinc-300 hover:bg-white/5"}`}>{d}+ days</button>
          ))}
        </div>
        {failed && <div className="mt-4 text-sm text-zinc-400">The list could not be loaded. Refresh the page and try again.</div>}
        {!failed && data && data.items.length === 0 && <div className="mt-4 text-sm text-zinc-500" data-testid="admin-at-risk-empty">Nobody right now. Everyone with Premium has visited in the last {days} days.</div>}
        {!failed && data && data.items.length > 0 && (
          <div className="mt-2 divide-y divide-white/10" data-testid="admin-at-risk-list">
            {data.items.map((u) => (
              <div key={u.id} data-testid={`admin-at-risk-${u.email}`} className="py-3 flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4">
                <div className="min-w-0 flex-1">
                  <div className="font-medium truncate">{u.name || u.email}</div>
                  <div className="text-xs text-zinc-500 truncate">{u.email}</div>
                </div>
                <div className="text-xs text-zinc-400 sm:text-right">
                  Last visit {u.days_away} days ago{u.typical_gap_days != null ? `, usually ${gapText(u.typical_gap_days)}` : ""}
                  {u.ending && <span className="block text-amber-300">Already canceled, ends at the end of the paid month</span>}
                </div>
                <a href={`mailto:${u.email}`} data-testid={`admin-at-risk-mail-${u.email}`} className="self-start sm:self-auto px-3 py-1.5 rounded-full border border-white/20 hover:bg-white/5 text-xs">Email them</a>
              </div>
            ))}
            {data.total > data.items.length && <div className="pt-3 text-xs text-zinc-500">Showing the {data.items.length} who have been away longest, out of {data.total}.</div>}
          </div>
        )}
      </div>
    </div>
  );
}
